import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Modal, PanelGroup, ButtonToolbar, Button} from 'react-bootstrap'
import extract from '../../core/extract'
import phonez from '../../core/phonez'
import Selector from '../../core/components/Selector'
import Icon from '../../core/components/Icon'
import {queryActivityRef, queryOpeningTicketPurposeRef} from '../../reference/actions'
import {queryProviderSuggest} from '../actions'
import {resolveActivities} from '../models'
import i18n from '../i18n'
import UpdateInterventionPeriodPanel from './UpdateInterventionPeriodPanel'
import style from './ProviderSuggestSelector.less'

function interventionPeriodAggregator(result, activity) {
    result.push(...activity.interventionPeriods)
    return result
}

function findReferenceInterventionPeriod(activities) {
    for (var i = 0 ; i < activities.length ; i++) {
        const activity = activities[i]
        const referenceInterventionPeriod = activity.interventionPeriods.find((ip) => ip.reference)
        if (referenceInterventionPeriod) return referenceInterventionPeriod
    }
}

class ProviderSuggestSelector extends Component {
    static propTypes = {
        company: PropTypes.object.isRequired,
        patrimony: PropTypes.object.isRequired,
        activities: PropTypes.array.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    componentWillMount() {
        const {dispatch, company, patrimony, activities} = this.props
        dispatch(queryProviderSuggest({patrimonyUid: patrimony.uid, activityUid: activities}))
        dispatch(queryActivityRef())
        dispatch(queryOpeningTicketPurposeRef(company.uid))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.activities != this.props.activities
            || nextProps.patrimony != this.props.patrimony) {
            const {dispatch, patrimony, activities} = nextProps

            dispatch(queryProviderSuggest({patrimonyUid: patrimony.uid, activityUid: activities}))
        }

        if (this.props.company != nextProps.company) {
            const {dispatch, company} = nextProps

            dispatch(queryOpeningTicketPurposeRef(company.uid))
        }
    }

    _openPanel(key) {
        const {activeKey} = this.state

        const nextActiveKey = activeKey != key && key || null
        this.setState({activeKey: nextActiveKey})
    }

    _openModal(event, activeProvider) {
        event.preventDefault()
        event.stopPropagation()

        const referenceInterventionPeriod = findReferenceInterventionPeriod(activeProvider.activities)
        const activeKey = referenceInterventionPeriod && referenceInterventionPeriod.uid
        this.setState({modalOpened: true, activeProvider, activeKey})
    }

    _closeModal() {
        this.setState({modalOpened: false, activeProvider: null, activeKey: null})
    }

    render() {
        const {dispatch, activityReference, openingTicketPurposeReference, suggest, company, patrimony, activities, ...others} = this.props
        const {modalOpened, activeProvider, activeKey} = this.state

        const displayProvider = (provider) => (
            <div className={style.provider}>
                <Icon icon='some icon' size='xs' />
                <div className={style.container}>
                    <p>{provider.name}</p>
                    <p>
                        {resolveActivities(activityReference, provider.activities).map((activity, index) => (
                            <small
                                key={index}>
                                {index > 0 && (<span> - </span>)}
                                <span>{activity.label}</span>
                            </small>
                        ))}
                    </p>
                </div>
                <a
                    href=''
                    onClick={(e) => this._openModal(e, provider)}>
                    {i18n.showMore}
                </a>
            </div>
        )

        return (
            <div>
                <Selector
                    source={suggest}
                    identify={(c) => c.uid}
                    display={displayProvider}
                    {...others} />
                {activeProvider && (
                    <Modal
                        show={modalOpened}
                        onHide={() => this._closeModal()}>
                        <Modal.Header>
                            <Modal.Title>{activeProvider.name}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <ul className={style.data}>
                                {activeProvider.contactInfos && activeProvider.contactInfos.phones.length > 0 && (
                                    <li>
                                        <label>> {i18n.phone} :</label>
                                        {activeProvider.contactInfos.phones.map((phone, index) => (
                                            <span key={index}>
                                                {index > 0 && (<span> |</span>)}
                                                <span> {phonez(phone).format()}</span>
                                            </span>
                                        ))}
                                    </li>
                                )}
                                {activeProvider.contactInfos && activeProvider.contactInfos.emails.length > 0 && (
                                    <li>
                                        <label>> {i18n.email} :</label>
                                        {activeProvider.contactInfos.emails.map((email, index) => (
                                            <span key={index}>
                                                {index > 0 && (<span> |</span>)}
                                                <span> {email}</span>
                                            </span>
                                        ))}
                                    </li>
                                )}
                                {activeProvider.contactInfos && activeProvider.contactInfos.fax.length > 0 && (
                                    <li>
                                        <label>> {i18n.fax} :</label>
                                        {activeProvider.contactInfos.fax.map((fax, index) => (
                                            <span key={index}>
                                                {index > 0 && (<span> |</span>)}
                                                <span> {phonez(fax).format()}</span>
                                            </span>
                                        ))}
                                    </li>
                                )}
                            </ul>
                            <PanelGroup accordion
                                activeKey={activeKey}
                                onSelect={(k) => this._openPanel(k)}>
                                {activeProvider.activities.reduce(interventionPeriodAggregator, []).map((interventionPeriod) => (
                                    <UpdateInterventionPeriodPanel
                                        key={interventionPeriod.uid}
                                        eventKey={interventionPeriod.uid}
                                        interventionPeriod={interventionPeriod}
                                        openingTicketPurposeReference={openingTicketPurposeReference}
                                        patrimony={patrimony} />
                                ))}
                            </PanelGroup>
                            <ButtonToolbar>
                                <Button
                                    bsSize='large'
                                    onClick={() => this._closeModal()}>
                                    {i18n.close}
                                </Button>
                            </ButtonToolbar>
                        </Modal.Body>
                    </Modal>
                )}
            </div>
        )
    }
}

ProviderSuggestSelector = connect((state) => ({
    activityReference: state.reference.activityRef,
    openingTicketPurposeReference: state.reference.openingTicketPurposeRef,
    suggest: state.provider.suggest
}))(ProviderSuggestSelector)

export default ProviderSuggestSelector


// WEBPACK FOOTER //
// ./lib/provider/components/ProviderSuggestSelector.js